// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageSearchQueries_container__2b-G0"};